<template>
    <div>
        <div>
            <div class="c-responsive-fixwidth">
                <div class="o-main-content-area">
                    <div class="table_header_wrapper">
                        <h1 class="h1">
                            Employees 911 Availability
                        </h1>
                        <div class="filter-options">
                            <div class="input-group stylish-input-group">
                                <input 
                                    id="search-input-employee" 
                                    type="text" class="form-control" 
                                    placeholder="Search" 
                                    v-model="search_query" 
                                    v-on:keyup="getEmployeesBySearch()" 
                                    autofocus
                                >
                                <span class="input-group-addon">
                                <button type="submit">
                                    <span class=""><i class="fa fa-search" aria-hidden="true"></i></span>
                                </button>
                                </span>
                            </div>
                            <div>
                                
                            </div>
                        </div>

                        <div class="mt-30">
                            <div class="col-md-12 o-tab-area o-no-padding">
                                <ul class="o-tab-view o-tab-view--text">
                                    <li href="javascript: void(0)" @click="changeToDailyAvailability()">
                                        <a :class="{ 'active': tab=='daily_available' }">
                                            Daily Available
                                        </a>
                                    </li>
                                    <li href="javascript: void(0)" @click="changeToNotBooked()">
                                        <a :class="{ 'active': tab=='not_booked' }">
                                            Not Booked
                                        </a>
                                    </li>
                                    <li href="javascript: void(0)" v-if="tab=='not_booked'" class="ml-20">
                                        <label>Start:</label>
                                        <a class="start-now">
                                            Now
                                        </a>
                                    </li>
                                    <li class="ml-20 mt-10" v-if="tab=='not_booked'">
                                        <label>End:</label>
                                    </li>
                                    <li href="javascript: void(0)" v-if="tab=='not_booked'">
                                        <div class="o-custom-dropdown">
                                            <select v-model="end_time_slot" class="form-control" @change="getNotBookedEmployees()">
                                                <option disabled value="">Select call duration</option>
                                                <option v-for="(item,itemIdx) in timeSlots" :key="itemIdx" :value="item.value">{{ item.label }}</option>                                    
                                            </select>
                                        </div>
                                    </li>
                                    <li class="ml-20 mt-10" v-if="tab=='not_booked'">
                                        <label>Status Level:</label>
                                    </li>
                                    <li href="javascript: void(0)" v-if="tab=='not_booked'">
                                        <div class="o-custom-dropdown">
                                            <select v-model="selectedStatusId" class="form-control" @change="getNotBookedEmployees()">
                                                <option v-for="(status, sIndex) in statusList" :key="sIndex" :value="status.id">{{status.name}}</option>
                                                <option value="">All</option>                                    
                                            </select>
                                        </div>
                                    </li>
                                    <li class="ml-20 mt-10" v-if="tab=='not_booked'">
                                        <label>Sort By:</label>
                                    </li>
                                    <li href="javascript: void(0)" v-if="tab=='not_booked'">
                                        <div class="o-custom-dropdown">
                                            <select v-model="selectedSortType" class="form-control" @change="getNotBookedEmployees()">
                                                <option value="">- - - Select - - -</option>
                                                <option value="fname_asc">FirstLast (Employee name)</option>
                                                <option value="fname_desc">LastFirst (Employee name)</option>

                                                <option value="wishlist_asc">Wishlist Timestamp (Ascending)</option>
                                                <option value="wishlist_desc">Wishlist Timestamp (Decending)</option>

                                                <option value="participation_asc">Participation (Ascending)</option>
                                                <option value="participation_desc">Participation (Decending)</option>

                                                <option value="emp_seniority">Employee Seniority (Ascending)</option>
                                                <option value="emp_seniority_desc">Employee Seniority (Decending)</option>


                                                <option value="skill_seniority">Skill Seniority (Ascending)</option>
                                                <option value="skill_seniority_desc">Skill Seniority (Decending)</option>

                                                <option value="location_asc">Location (Ascending)</option>
                                                <option value="location_desc">Location (Decending)</option>
                                                <option value="last_offer">Last Offer</option>
                                                <option value="shift_total_asc">Total Shift (Ascending)</option>
                                                <option value="shift_total_desc">Total Shift (Decending)</option>

                                                <option value="shift_weekly_asc">Weekly Shift (Ascending)</option>
                                                <option value="shift_weekly_desc">Weekly Shift (Decending)</option>

                                                <option value="shift_july_june_asc">Shift July June (Ascending)</option>
                                                <option value="shift_july_june_desc">Shift July June (Decending)</option>

                                                <option value="shift_YTD_asc">Shift YTD (Ascending)</option>
                                                <option value="shift_YTD_desc">Shift YTD (Decending)</option>

                                                <option value="decline_total__asc">Decline Total (Ascending)</option>
                                                <option value="decline_total__desc">Decline Total (Decending)</option>

                                                <option value="decline_weekly_asc">Decline Weekly (Ascending)</option>
                                                <option value="decline_weekly_desc">Decline Weekly (Decending)</option>

                                                <option value="decline_july_june_asc">Decline July June (Ascending)</option>
                                                <option value="decline_july_june_desc">Decline July June (Decending)</option>

                                                <option value="decline_YTD_asc">Declines YTD (Ascending)</option>
                                                <option value="decline_YTD_desc">Declines YTD (Decending)</option>

                                                <option value="phone_asc">Cell Phone (Ascending)</option>
                                                <option value="phone_desc">Cell Phone (Decending)</option>

                                                <option value="conflicts_asc">Conflicts (Ascending)</option>
                                                <option value="conflicts_desc">Conflicts (Decending)</option>

                                            </select>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="o-skills-listing">
                        <div v-if="tab=='daily_available'">
                            <div class="row">
                                <div class="col col-sm-12">
                                    <div class="o-scheduleTable--daily">
                                        <div 
                                            ref="scrollContainer"
                                            v-infinite-scroll="{ handler: handleScroll, distance: 10 }" 
                                            v-loading="loading"
                                            style="min-height: 1px;"
                                        >
                                            <div 
                                                v-for="(employee,index) in availableEmployees" :key="index" 
                                                class="o-calls-table c-common-gradient c-common-box-shadow c-radius3 c-margin-bottom-10 employees-list-table-align employees-list-table"
                                            >
                                                <div class="calls-table-row">
                                                    <div class="calls-table-cell">
                                                        <div class="o-right-side-padding5" @click="goToEmployeeDetails(employee)">
                                                            <div class="calls-table-cell-inner-table o-modal-trigger" data-toggle="modal" data-target="#employeeSummaryModal">
                                                                <div class="o-accordion-subtext user-icon o-list-user-img">
                                                                    <div class="o-post-logged o-post-logged--table-user">
                                                                        <div class="o-user-profile-img o-header-profile-pic">
                                                                            <div v-if="employee.employable">
                                                                                <img 
                                                                                    v-if="employee.employable.image && employee.employable.image != '' &&employee.employable.image != 'NULL'"
                                                                                    :src="(employee.employable.image)"  id='img-upload'/>
                                                                                <img 
                                                                                    v-if="!employee.employable.image && employee.employable.image == '' ||employee.employable.image == 'NULL'" 
                                                                                    src="static/assets/images/user1.png" id='img-upload' />
                                                                            </div> 
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="o-accordion-subtext o-rowtable-text">
                                                                    <span>Name:
                                                                        <el-tooltip class="item" effect="dark" content="Click to Copy Employee & User Id" placement="top-start">
                                                                            <a 
                                                                                @click.stop="copyText('Employee Id: '+employee.employee_id+' , User Id: '
                                                                                +employee.employable_id)">
                                                                                <i class="fa fa-paste"></i>
                                                                            </a>
                                                                        </el-tooltip>
                                                                    </span>
                                                                    <div>
                                                                        {{employee.employable ? ((selectedSortType=='fname_asc')?employee.employable.first_name+" "
                                                                        +employee.employable.last_name:(selectedSortType=='fname_desc'?employee.employable.last_name+", "+
                                                                        employee.employable.first_name:employee.employable.first_name+" "+employee.employable.last_name)):'--'}} 
                                                                        <span v-if="employee.merge_notes">
                                                                            {{ employee.merge_notes }}
                                                                        </span>                                                                
                                                                    </div>                                                            
                                                                </div>                                                        
                                                            </div>
                                                        </div>                                                
                                                    </div>

                                                    <div class="calls-table-cell">
                                                        <div 
                                                            class="o-right-side-padding5 block-seniority" @click="navigateToEditEmployee(employee)" 
                                                            v-if="(employee.employee_status&&employee.employee_status.name) || employee.seniority"
                                                        >
                                                            <div class="display-status" v-if="employee.employee_status && employee.employee_status.name">
                                                                    {{ employee.employee_status.name }}
                                                            </div>
                                                            <div class="calls-table-cell-inner-table" v-if="employee.seniority">
                                                                <div class="o-accordion-subtext o-rowtable-text">
                                                                    <span class="seniority-display">Sen: {{ getRoundOffSkillSeniority(employee.seniority) }}</span>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="o-right-side-padding5" @click="navigateToEditEmployee(employee)" v-else>
                                                            <div class="display-add-status">
                                                                >> Add Status and Seniority
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="calls-table-cell">
                                                        <div class="o-accordion-subtext o-rowtable-text">
                                                            <div>
                                                                <span>MS:</span>
                                                                <span class="ms-doh-text">
                                                                    {{employee.member_since && employee.member_since !== '0000-00-00 00:00:00' 
                                                                    ? getUserDateFormat(employee.member_since):'  '}}
                                                                </span>
                                                            </div>
                                                            <div>
                                                                <span>DOH:</span>
                                                                <span class="ms-doh-text">
                                                                    {{employee.date_of_hire && employee.date_of_hire !== '0000-00-00 00:00:00'  
                                                                    ? getUserDateFormat(employee.date_of_hire):'  '}}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="calls-table-cell">
                                                        <div class="table-td-border-right table-td-border-left o-left-side-padding5 o-right-side-padding5">
                                                            <div class="o-accordion-subtext o-rowtable-text o-notify-cell">
                                                                <div class="notify-icon d-inline">
                                                                    <a @click="viewSchedule(employee.employee_id)" href="javascript: void(0)">
                                                                        <i aria-hidden="true" class="fa fa-eye"></i>
                                                                    </a>
                                                                </div>
                                                                <div v-if="employee.resume_url" class="notify-icon d-inline">
                                                                    <a @click="goToResume(employee.employable.id, employee.resume_url)">
                                                                        <i aria-hidden="true" class="fa fa-graduation-cap"></i>
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="calls-table-cell">
                                                        <div class="table-td-border-right o-right-side-padding5">
                                                            <div class="o-accordion-subtext o-rowtable-text">
                                                                <span>Email ID:
                                                                    <el-tooltip class="item" effect="dark" content="Click to Copy Email" placement="top-end">
                                                                        <a @click.stop="copyText(employee.employable?employee.employable.email:'')"><i class="fa fa-paste"></i></a>
                                                                    </el-tooltip>
                                                                </span>
                                                                <div>{{employee.employable ? employee.employable.email:'--'}}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="calls-table-cell">
                                                        <div class="table-td-border-right o-right-side-padding5">
                                                            <div  class="o-accordion-subtext o-rowtable-text">
                                                                <span>Phone:</span>
                                                                <div v-if="employee.employable">
                                                                    <div v-for="(phone,phoneIndex) in employee.employable.phones" 
                                                                    :key="phoneIndex" 
                                                                    v-if="phone.label=='Home phone' || phone.label=='home'">
                                                                        <a :href="'tel:'+getClientContactFormat(phone.phone_number)" class="phone-number-display">
                                                                            {{ phone.phone_number ? getClientContactFormat(phone.phone_number) : '' }}
                                                                        </a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="calls-table-cell">
                                                        <div class="table-td-border-right o-right-side-padding5">
                                                            <div class="o-accordion-subtext o-rowtable-text">
                                                                <span>Cell:</span>
                                                                <div v-if="employee.employable">
                                                                    <div 
                                                                        v-for="(phone,phoneIndex) in employee.employable.phones" :key="phoneIndex"
                                                                        v-if="phone.label=='Cell phone' ||  phone.label=='mobile' || phone.label=='cell'"
                                                                    >
                                                                        <a :href="'tel:'+getClientContactFormat(phone.phone_number)" class="phone-number-display">
                                                                            {{ phone.phone_number ? getClientContactFormat(phone.phone_number) : '' }}
                                                                        </a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>  

                                                    <div class="calls-table-cell" v-if="showCustom != 0 && customField1 != null && customField1 != '' && customField1 != 'NULL'">
                                                        <div class="o-left-side-padding5">
                                                            <div class="o-accordion-subtext o-rowtable-text">
                                                                    <span>
                                                                    {{ customField1 ? customField1 : ''}}
                                                                    </span>
                                                                    <div>
                                                                    <div>
                                                                    {{ getCustomField1(employee.custom_field1) }}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="calls-table-cell" v-if="showCustom != 0 && customField2 != null && customField2 != '' && customField1 != 'NULL'">
                                                        <div class="table-td-border-left o-left-side-padding5">
                                                            <div class="o-accordion-subtext o-rowtable-text">
                                                                <span>
                                                                    {{customField2 ? customField2: ''}}
                                                                </span>
                                                                <div>
                                                                    <div>
                                                                        {{ getCustomField2(employee.custom_field2)&&getCustomField2(employee.custom_field2) != '' ?
                                                                        getCustomField2(employee.custom_field2) : "--"  }}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="calls-table-cell">
                                                        <div class="table-td-border-left o-left-side-padding5 o-right-side-padding5">
                                                            <div class="o-accordion-subtext o-rowtable-text o-notify-cell">
                                                                <div class="notify-icon d-inline">
                                                                    <a 
                                                                        @click="openCreateCallPopup(employee,'backTo'+index)" href="javascript: void(0)" 
                                                                        class="c-common-btn c-common-btn--xsmall c-common-btn--inverse-icon-green c-common-btn-min-width"
                                                                    >
                                                                            <i data-v-d8a8ddae="" aria-hidden="true" class="fa fa-plus-circle"></i> 
                                                                            Create Call
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div v-if="availableEmployees.length==0 && afterApi">
                                <div class="c-common-space c-common-gradient c-common-box-shadow c-radius3">
                                    <div class="col-md-12 no-job-dispaly">
                                        No Employees Available
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div v-else-if="tab=='not_booked'">
                            <div class="row"></div>
                            
                            <div class="mt-30">
                                <div class="row c-common-space c-common-gradient c-common-box-shadow c-radius3">
                                    <div class="o-ndividualArea">
                                        <div class="o-ndividualTable assigntab" style="padding-top: 0px;" v-if="callEndTime!=''">
                                            <div class="extra-list-table-outer table_main_content">
                                                <div class="tbl-header">
                                                    <div class="o-calls-table bulk-table-list c-radius3 table_header_black table_1">
                                                        <div class="calls-table-row">
                                                            <div class="calls-table-cell tcell_1">
                                                                <div class="table-td-border-right">
                                                                    <div class="calls-table-cell-inner-table">
                                                                        <div class="table_heading th_cell_1">List</div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="calls-table-cell tcell_1">
                                                            </div>

                                                            <dynamicHeader 
                                                                v-for="(item, index) in callAssignmentSettings" 
                                                                :client="client" :columnLabel="item" :sortType="selectedSortType" :key="index"
                                                            ></dynamicHeader>

                                                            <div class="calls-table-cell tcell_1">
                                                                <div class="table-td-border-right">
                                                                    <div class="calls-table-cell-inner-table">
                                                                        <div class="table_heading th_cell_6">HTS</div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="calls-table-cell tcell_8">
                                                                <div class="table-td-border-right border-right-none">
                                                                    <div class="calls-table-cell-inner-table">
                                                                        <div class="table_heading th_cell_6">Action</div>
                                                                    </div>
                                                                </div>
                                                            </div>  
                                                        </div>
                                                    </div>
                                                </div>
                                                
                                                <v-infinite-scroll
                                                    id="page-data-focus"
                                                    ref="scrollContainer"
                                                    tabindex="1"
                                                    :loading="loading"
                                                    :offset="100"
                                                    class="tbl-content"
                                                    @bottom="onPageChangeScrollDown"
                                                    @top="onPageChangeScrollUp"
                                                >

                                                    <div 
                                                        v-for="(employee, row) in notBookedEmployees" :key="employee.id" 
                                                        :style="{'border': '2px solid '+employee.link_color, 'box-shadow': '0px 0px 5px 0px '+employee.link_color}" 
                                                        class="o-calls-table extra-list-table bulk-table-list c-common-gradient c-radius3 table_1"
                                                    >
                                                        <div 
                                                            class="calls-table-row" 
                                                            v-if="!recurringUnavailability(employee.available_times )&& !getDeclineStatus(employee.call_actions) && 
                                                            !getCallOutStatus(employee.call_actions)">
                                                                <div class="calls-table-cell tcell_1 calls-table-alphabet" :style="{'background-color': employee.link_color}">
                                                                    <span>{{getStatusName(employee.status_name)}} <br/> ({{employee.status_priority}})</span>
                                                                </div>
                                                          
                                                                <div class="calls-table-cell tcell_1">
                                                                    <div class="o-post-logged o-post-logged--table-user">
                                                                        <div class="o-user-profile-img" :id="'scrollTop'+row">
                                                                            <img v-if="employee.image!='' && employee.image!='NULL' && !recurringUnavailability(employee.available_times) & 
                                                                            !getDeclineStatus(employee.call_actions) && !getCallOutStatus(employee.call_actions)" :src="(employee.image)" 
                                                                            id='img-upload'/>
                                                                            <img v-if="employee.image == '' || employee.image == 'NULL' && 
                                                                            !recurringUnavailability(employee.available_times) 
                                                                            && !getDeclineStatus(employee.call_actions) && !getCallOutStatus(employee.call_actions)" 
                                                                            src="static/assets/images/user1.png" id='img-upload'/>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            
                                                                <dynamicColumns 
                                                                    v-for="(item, index) in callAssignmentSettings" :key="index"
                                                                    :employee="employee" :columnLabel="item" :client="client" :selectedSortType="selectedSortType" 
                                                                    :callStartTime="callStartTime" :callEndTime="callEndTime" :userDateFormat="userDateFormat" 
                                                                    :userTimeFormat="userTimeFormat">
                                                                </dynamicColumns>  
                                                                <div class="calls-table-cell tcell_1 ">
                                                                    <div class="table-td-border-right" 
                                                                    v-if="(employee.bookings.length==0 && !recurringUnavailability(employee.available_times) && 
                                                                    !getDeclineStatus(employee.call_actions) && !getCallOutStatus(employee.call_actions)&&employee.hts.length==0)">
                                                                        <a @click="ckeckHTS(employee.id)"><i class="fa fa-eye" aria-hidden="true"></i></a>
                                                                    </div>
                                                                </div>
                                                            <div class="calls-table-cell tcell_8">
                                                                <div 
                                                                    :class="{'isDisabled':!getPower('callAssign')}" v-if="!recurringUnavailability(employee.available_times) && 
                                                                    !getDeclineStatus(employee.call_actions)&&!getCallOutStatus(employee.call_actions)"
                                                                >
                                                                    <a href="javascript: void(0)" :id="'btn-'+employee.id" 
                                                                        @click="openCreateCallPopup(employee,'backTo'+row)" 
                                                                        :class="((employee.bookings.length==0 || 
                                                                        !checkThisClickCooking(employee.bookings)) && 
                                                                        !recurringUnavailability(employee.available_times) && 
                                                                        !getCallOutStatus(employee.call_actions) && 
                                                                        !getDeclineStatus(employee.call_actions)) ? 
                                                                        'c-common-btn c-common-btn--small c-common-btn--inverse-icon-green' : 
                                                                        'c-common-btn c-common-btn--small c-common-btn--inverse-icon-green isDisabled'"
                                                                    >
                                                                        Create Call
                                                                    </a>
                                                                    
                                                                </div>
                                                            </div>                     
                                                        </div>
                                                        <div v-else-if="checkRecurringUnavailability(employee,row)" class="calls-table-row">No Employees Found</div>
                                                    </div>

                                                    <div v-if="loading" 
                                                        v-loading="loading" 
                                                        class="o-calls-table extra-list-table bulk-table-list c-common-gradient c-common-box-shadow c-radius3 table_1" 
                                                        style="height: 50px;"
                                                    >
                                                        <div class="calls-table-row">
                                                            <div class="calls-table-cell" style="height: 60px;">
                                                                <div class="o-accordion-subtext o-rowtable-text">
                                                                    <div></div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div v-if="(notBookedEmployees.length==0) && apiData && !loading" 
                                                        v-loading="loading" class="o-calls-table extra-list-table bulk-table-list c-common-gradient c-common-box-shadow c-radius3 table_1" 
                                                        style="height: 50px;">
                                                        <div class="calls-table-row">
                                                            <div class="calls-table-cell" style="height: 60px;">
                                                                <div class="o-accordion-subtext o-rowtable-text">
                                                                    <div>Empty Employee List</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </v-infinite-scroll>
                                            </div>
                                            
                                            <div class="el-pagination-assign">
                                                <el-pagination
                                                    :current-page.sync="currentPage"
                                                    :page-size="pageSize"
                                                    :total="totalLimit"
                                                    layout="prev, pager, next"
                                                    @current-change="onPageChange"
                                                />
                                            </div>
                                        </div>
                                        <div v-else class="o-ndividualTable assigntab">
                                            Please select end-time slot!
                                        </div>                                        
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="openOtherConflictsModal">
            <modal name="otbConflictPop"  height="auto" :scrollable="false" class="modal-dialog modal-sm modal--custom">
                <div  tabindex="-1" role="dialog">
                    <div  role="document">
                        <div class="modal-content o-common-modal-content">
                            <div class="modal-header text-center">
                                <button @click="closeOtbConflictPop()" 
                                type="button" class="close custom-modal--close" 
                                data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                                <h1 class="modal-title">WARNING !</h1>
                            </div>
                            <div class="modal-body">
                                    <div class="obt-conflict-body">
                                            Selecting this user will create the opportunity for a 2x Booking in another client.
                                            Proceed with Caution and make direct contact with the employee!
                                    </div>   
                                </div>                        

                                <div class="modal-footer text-center">
                                <a id="btn-bulk-assign-modal" 
                                    href="javascript: void(0)" 
                                    @click="closeOtbConflictPop()" 
                                    class="c-common-btn c-common-btn--small obt-modal-cancel-btn"
                                > 
                                    Cancel
                                </a>
                                <a id="btn-bulk-assign-modal" 
                                    href="javascript: void(0)" 
                                    @click="proceedWithConflict(selectedEmployeeID)" 
                                    class="c-common-btn c-common-btn--small obt-modal-proceed-btn"
                                >
                                    Proceed
                                </a>
                            </div>
                        
                        </div>
                    </div>
                </div>
            </modal> 
        </div>

        <modal name="create-call-popup"  height="auto" width="60%" :clickToClose="false" :scrollable="true" class="modal-dialog modal-sm">
            <div class="employee-summary" tabindex="-1" role="dialog">
                <div  role="document" v-loading="modalLoading">            
                    <div class="modal-content o-common-modal-content">
                        <div class="modal-header u-no-border text-center modal-header--heading">
                            <button 
                                @click="closeCreateCallPopup()" 
                                type="button" 
                                class="close custom-modal--close" 
                                data-dismiss="modal" 
                                aria-label="Close"
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                            <h4 class="modal-title">Create Call and confirm</h4>
                        </div>
                        <div class="modal-body c-common-box-shadow o-modal-body pb-45">
                            <div class="bulk-filter">
                                <h2 class="h2 text-center o-modal-link">{{selectedJob&&selectedJob.name?selectedJob.name:''}}</h2>
                                <div class="c-common-space o-subtitleHeading">
                                    <div class="col-sm-5">
                                        <div class="form-group">
                                            <label class="common-label-text common-label-text-block">Job/Event:</label>
                                            <div class="o-cutsomSelect">
                                                <select v-model="selectedJob" class="form-control">
                                                    <option value="" disabled>Select Job</option>
                                                    <option v-for="(job,jobIdx) in jobsList" :key="jobIdx" :value="job.id">{{ job.title + ' - ' + job.job_number }}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>                                    
                                </div>
                                <div class="row">
                                    <div class="col-sm-12">
                                        <hr class="o-modal-separetor">
                                    </div>
                                </div>
                            </div>
                            
                            <div class="add-bulk-form">
                                <div class="c-common-space">
                                    <h2 class="h2">Created call will have the following values:</h2>
                                </div>
                                <div class="row">
                                    <div class="col-sm-3">
                                        <div class="form-group">
                                            <label class="common-label-text common-label-text-block">Start Date:</label>
                                            <el-col :span="50">
                                            <el-date-picker
                                                name="date"
                                                class="custom_date"
                                                v-validate="{ required: true}"
                                                v-model="addCall.date"
                                                type="date"
                                                :format="getDisplayFormat()"
                                                value-format="yyyy-MM-dd"
                                                placeholder="Today"
                                                disabled>
                                            </el-date-picker>
                                                <!-- :picker-options="pickerOptions" -->
                                            </el-col>
                                        </div>
                                    </div>
                                    <div class="col-sm-3">
                                        <div class="form-group">
                                            <label class="common-label-text common-label-text-block">Position:</label>
                                            <div class="o-custom-dropdown">
                                                <select v-model="addCall.position" class="form-control">
                                                    <option value="" disabled>Select Skill</option>
                                                    <option v-for="(position,posIdx) in skillList" :key="posIdx" :value="position.id">{{position.name}}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-3">
                                        <div class="form-group">
                                            <label class="common-label-text common-label-text-block">Start time:</label>
                                            <div class="o-custom-dropdown">
                                                <date-picker placeholder="HH:MM AM" name="start" v-validate="{required: true}" v-model="addCall.start" :config="config"></date-picker>
                                                <span class="o-custom-drop-time"><i class="fa fa-clock-o" aria-hidden="true"></i></span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-3">
                                        <div class="form-group">
                                            <label class="common-label-text common-label-text-block">End time</label>
                                            <div class="o-custom-dropdown">
                                            <date-picker placeholder="HH:MM AM" name="end" v-validate="{required: true}" v-model="addCall.end" :config="config"></date-picker>
                                            <span class="o-custom-drop-time"><i class="fa fa-clock-o" aria-hidden="true"></i></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>                                    
                            </div>
                        </div>

                        <div class="modal-footer text-center">
                            <ul class="o-filter-area">
                                <li>
                                    <a href="javascript: void(0)" 
                                        @click="closeCreateCallPopup()" 
                                        data-dismiss="modal" aria-label="Close" 
                                        class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"
                                    >
                                        <i class="fa fa-minus-circle" aria-hidden="true"></i> 
                                        Cancel
                                    </a>
                                </li>
                                <li>
                                    <a href="javascript: void(0)" 
                                        @click="saveCall911AssignAndConfirm()" 
                                        class="c-common-btn c-common-btn--large c-common-btn--green"
                                    >
                                        <i class="fa fa-plus" aria-hidden="true"></i> 
                                        Create Call
                                    </a>
                                </li>
                            </ul>
                        </div>              
                    </div>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
import service from '@/services.js';
import { global } from '@/global.js';
import dateTimeConvert from '@/timeConvert&Compare.js';
import { mapGetters } from 'vuex';
import dynamicColumns from '@/components/calls/assign/dynamicColumns911Availability';
import dynamicHeader from '@/components/calls/assign/dynamicHeader911Availability';
import { bus } from '@/main';


export default {
    data() {
        return {
            loading: false,
            tab: 'daily_available',
            savedEmployees: [],
            next_page: '',
            last_page: '',
            page_no: 3,
            selectedSortType: 'fname_asc',
            tempStatus: '',
            statusList: [],
            getBaseURL: '',
            search_query: '',
            customField1:'',
            customField2: '',
            showCustom: '',
            afterApi: false,
            selectedStatusId: 'all',
            selectedEmployee: '',
            modalLoading: false,
            skillList: [],
            jobsList:[],
            selectedJob: '',
            timeSlots: [
                { label: '24 H', value: 24 }, 
                { label: '12 H', value: 12 }, 
                { label: '10 H', value: 10 }, 
                { label: '8 H', value: 8 }, 
                { label: '6 H', value: 6 }, 
                { label: '4 H', value: 4 }
            ],
            addCall: {
                position: '',
                date: '',
                start: '',
                end: '',
                quantity: 1,
                rate: '',
                notes: ''
            },
            start_time: moment().format('YYYY-MM-DD HH:mm:ss'),
            end_time_slot: 12,
            inputValidation: '',
            config: {
                format: 'h:mm A',
                useCurrent: false,
                showClear: false,
                showClose: false,
                widgetPositioning: {
                    //vertical: 'top',
                    horizontal: 'right'
                },
                parseInputDate: (inputDate) => {
                    if (typeof inputDate === 'string') {
                    // Handle case where user inputs 3 or 4 digits (e.g., 800 or 1230)
                    const match = inputDate.match(/^(\d{1,2})(\d{2})?$/);

                    if (match) {
                        let hours = parseInt(match[1], 10);
                        let minutes = match[2] ? parseInt(match[2], 10) : 0;

                        // Adjust hours if necessary for AM/PM logic (optional)

                        // Return a Moment.js object
                        return moment({ hour: hours, minute: minutes });
                    }
                    }

                    // Default fallback to create a Moment object
                    return moment(inputDate, 'hh:mm A');
                }
            },
            pickerOptions: {
                disabledDate(time) {
                    return (time.getTime() < dataProps.getDates().jobStart || time.getTime() > dataProps.getDates().jobEnd);
                }
            },
            openOtherConflictsModal: false,
            callAssignmentSettings: [],
            availableEmployees: [],
            storeMore: [],
            notBookedEmployees: [],
            notBookedStoreMore: [],
            job: '',
            apiData:false,
            currentPage: 1,
            pageSize: 100,
            totalLimit: 0,
            selectedSkill: '',
            userDateFormat: null,
            userTimeFormat: null,
            callStartTime: '',
            callEndTime: '',
            isFirstPageLoad: false,
            lastLoadedPage: 0,
            isPaginationChange: false,
            scrollDirection: null,
            // assignPageSize: 100,
            // assignCurrentPage: 1,
            // assignTotalLimit: 0
        };

    },
    computed: {
        ...mapGetters({
            userToken: 'userToken',
            userRole: 'userRole',
            userRoleSlug: 'userRoleSlug',
            userClientID: 'userClientID',
            employeeId: 'employeeId',
            currentEmployeeID: 'currentEmployeeID',
            userID: 'userID',
            employeeStatusList:'employeeStatusList',
        })
    },
    methods: {
        getClientContactFormat(phone) {
            phone = phone ? phone.toString() : '';
            phone = phone.replace(/-/g, "");
            phone = phone.replace(/ /g, "");
            phone = phone.replace("(", "");
            phone = phone.replace(")", "");
            let result = '';
            if(phone&&phone.length==10) { 
                result = '+1'+phone;
            }else if(phone&&phone.length==11) {
                result = '+' + phone;
            }else if(phone&&phone.length) {
                result = phone;
            }
            return result;
        },

        checkRecurringUnavailability(employee,row) {
            this.notBookedEmployees.splice(row, 1);
            return true;
        },

        async getNotBookedEmployees() {
            this.callStartTime = moment().format('YYYY-MM-DD HH:mm:ss');
            this.callEndTime = moment(this.callStartTime,'YYYY-MM-DD HH:mm:ss').add(this.end_time_slot, 'hours').format('YYYY-MM-DD HH:mm:ss');
            await this.getAvailableEmployeesByTimeSlot();
        },

        async resetEmployeeAvailabilityList() {
            await service.post('employee/flushEmployeeAvailability', {}, {
                'Authorization': this.userToken,
                'cs3-context-role': this.userRole,
                'cs3-context-clientId': this.userClientID
            })
            .then((res) => {
                if(res.status) {}
            }).catch(error=>{
                console.log(error)
            })
        },

        getDisplayFormat(){
            var format = dateTimeConvert.getDateInputFormat();
            return format?format:'MM/dd/yyyy';
        },

        getDatePlaceholder(){
            return dateTimeConvert.getDatePlaceHolder();
        },
        
        async openCreateCallPopup(employee, id) {
            this.selectedEmployee = employee.id;
            this.$modal.show("create-call-popup");
            this.modalLoading = true;
            await this.getTodayJobList();
            await this.getSkills();
            this.modalLoading = false;  
            this.addCall = {
                date: '',
                start: '',
                end: '',          
                position: '',
            };
            this.addCall.date = moment().format('YYYY-MM-DD');
            this.addCall.start = moment().format('h:mm A');
            this.addCall.end = '';
            this.selectedJob = '';
        },

        closeCreateCallPopup() {
            this.$modal.hide("create-call-popup");
        },

        async getTodayJobList () {
            await service.get('job/getTodaysJob', {
                'Authorization': this.userToken,
                'cs3-context-clientId': this.userClientID,
            }).then((res) => {
                if(res.data) {

                }
                this.jobsList = res.data.result;
            }).catch((err) => {
                console.log(err);
            });
        },

        async getSkills() {
            await service.get('skill/getAllSkills', {
                'Authorization': this.userToken,
                'cs3-context-clientId': this.userClientID
            }).then((res) => {
                if(res.data&&res.data.result) {
                    this.skillList = res.data.result;
                }
            }).catch((err) => {
                console.log(err);
            });
        },

        async saveCall911AssignAndConfirm() {        
            this.modalLoading=true;
            this.$forceUpdate();

            this.inputValidation = "";  

            if(this.selectedJob == '' ){
                this.inputValidation = "Please select the job.";
            }
            else if(this.addCall.position == '' ){
                this.inputValidation = "Please select the position.";
            }
            
            else if(this.addCall.start == ''){
                this.inputValidation = "Please enter the Start Time.";
            }
            
            else if(this.addCall.end == ''){
                this.inputValidation = "Please enter the End Time.";
            }
            
            if(this.inputValidation){
                this.modalLoading = false;
                this.$notify({
                    title: this.$t('error'),
                    message: this.inputValidation,
                    type: 'error'
                });
                return;
            }

            let payload = {
                job_id: this.selectedJob,
                skill_id: this.addCall.position,
                start: this.addCall.date + " " + dateTimeConvert.convertTo24Hours(this.addCall.start),
                end: this.addCall.date + " " + dateTimeConvert.convertTo24Hours(this.addCall.end),
                employee_id: this.selectedEmployee,
                user_id: this.userID
            };

            if (moment(payload.start, 'YYYY-MM-DD HH:mm A').isAfter(moment(payload.end, 'YYYY-MM-DD HH:mm A'))) {
                payload.end=moment(payload.end, 'YYYY-MM-DD HH:mm:ss').add(1, 'days').format('YYYY-MM-DD HH:mm:ss');
            }
            
            service.post('call/call911AssignAndConfirm', payload, {
                'Authorization': this.userToken,
                'cs3-context-role': this.userRole,
                'cs3-context-clientId': this.userClientID
            }).then((res) => {
                this.modalLoading = false;
                if(res.data.status_code == '0') {
                    this.$notify({
                        title: 'Error',
                        message: res.data.status_message,
                        type: 'error'
                    });
                    return;
                }
                
                this.$notify({
                    title: 'Success',
                    message: 'Call Added Successfully.',
                    type: 'success'
                });
                this.getAvailableEmployeesList();
                this.getNotBookedEmployees();
                this.$modal.hide("create-call-popup");
            }).catch((err) => {
                console.log(err);
                this.$notify({
                    title: 'Error',
                    message: 'Something went wrong.',
                    type: 'error'
                });
                this.modalLoading = false;
            });
        },

        changeToDailyAvailability() {
        this.tab = 'daily_available';
        this.getAvailableEmployeesList();
        },

        changeToNotBooked() {
        this.tab = 'not_booked';
        this.getNotBookedEmployees();
        },

        async getClient(){
        await service.get('client/' + this.userClientID, {
            'Authorization': this.userToken
        }).
        then((res) => {
            this.client = res.data.result;
            this.customField1 = this.client.custom_field_1;
            this.customField2 = this.client.custom_field_2;
            this.showCustom = this.client.employee_title;
            this.selectedSortType = this.client.default_sort != '' ? this.client.default_sort : 'fname_asc';
            this.callAssignmentSettings = this.client.settings['call-assignment-config'];
            let phoneIndex = this.callAssignmentSettings.findIndex((ele) => ele == 'employee_cell_phone');
            if(phoneIndex < 0) {
                this.callAssignmentSettings.push('employee_cell_phone');
            }
            let wishListConfigIndex = this.callAssignmentSettings.findIndex((ele) => ele == 'wishlist');
            if(wishListConfigIndex>-1) {
                this.callAssignmentSettings.splice(wishListConfigIndex, 1);
            }
            let skillSeniorityConfigIndex = this.callAssignmentSettings.findIndex((ele) => ele == 'skill_seniority');
            if(wishListConfigIndex>-1) {
                this.callAssignmentSettings.splice(skillSeniorityConfigIndex, 1);
            }
            this.getAvailableEmployeesList();
        }).catch((err) => {
            console.log(err);
        });        
        },

        getAvailableEmployeesList() {
            this.$Progress.start();
            this.loading = true;
            this.afterApi = false;
            this.availableEmployees = [];
            this.savedEmployees = [];
            var self = this;
            service.get('employee/displayEmployeeAvailibilityList', {
                'Authorization': self.userToken,
                'cs3-context-role': self.userRole,
                'cs3-context-clientId': self.userClientID,
                'status': self.selectedStatusId,
                'sort': self.selectedSortType,
                'search': self.search_query,
            }).then((res) => {
                self.availableEmployees = res.data.result.data;
                self.$Progress.finish();
                self.last_page = res.data.result.total;
                self.next_page = res.data.result.next_page_url;
                self.loading = false;
                self.afterApi = true;
                if (self.next_page != null && self.next_page != "") {
                    service.getUrl(self.next_page, {
                        'Authorization': self.userToken,
                        'cs3-context-role': self.userRole,
                        'cs3-context-clientId': self.userClientID,
                        'status': self.selectedStatusId,
                        'sort': self.selectedSortType,
                        'search': self.search_query,
                    }).then((res) => {
                        self.savedEmployees = res.data.result.data;
                        self.next_page = res.data.result.next_page_url;

                    }).catch((err) => {
                        self.loading = false;
                        console.log(err);
                    });
                } 
            }).catch((err) => {
                console.log(err);
                self.loading = false;
                self.afterApi = true;
            });
        },

        async handleScroll(position) {               
            if (position !== "bottom") return; 
            await this.loadMore();
        },

        async loadMore() {
            var arr = this.availableEmployees;
            if (this.savedEmployees.length != 0) {
                this.savedEmployees.forEach(function(entry) {
                    arr.push(entry);
                })
                this.savedEmployees=[];
                if (this.next_page != null || this.next_page != "") {
                    await service.getUrl(this.next_page, {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID,
                        'status': this.selectedStatusId,
                        'sort': this.selectedSortType,
                        'search': this.search_query,
                    }).then((res) => {
                        this.savedEmployees = res.data.result.data;
                        this.page_no += 1;
                        this.next_page = res.data.result.next_page_url;
                    }).catch((err) => {
                        console.log(err);
                    });
                }else
                    this.savedEmployees = [];
            }
            this.$nextTick(() => {
                if (this.$refs.scrollContainer && this.$refs.scrollContainer._checkScroll) {
                    this.$refs.scrollContainer._checkScroll();
                }
            });

        },

        getEmployeesBySearch() {
            this.loading=true;
            setTimeout(()=>{
                this.isFirstPageLoad = true;
                if(this.tab == 'daily_available' ) {
                    this.getAvailableEmployeesList();
                    this.loading=false;
                }else {
                    this.getAvailableEmployeesByTimeSlot();
                    this.loading = false
                }
            }, 500);
            this.loading = false;
        },

        changeSortType() {
            if(this.tab=="daily_available") {
                this.getAvailableEmployeesList();
            }else {
                this.getAvailableEmployeesByTimeSlot();
            }
        },

        copyText(text){
            var textarea = document.createElement("textarea");
            textarea.textContent = text;
            textarea.style.position = "fixed";
            document.body.appendChild(textarea);
            textarea.select();
            try {
                document.execCommand("copy");
                this.$notify({
                    title: this.$t('success'),
                    message: 'Copied to clipboard.',
                    type: 'success'
                });              
            } catch (ex) {
                console.warn("Copy to clipboard failed.", ex);
                return false;
            } finally {
                document.body.removeChild(textarea);
            }
        },

        viewSchedule(empId){
            this.$router.push({
                'path': '/schedule/'+ btoa(empId)
            });
        },

        goToEmployeeDetails(employee) {
            this.$store.dispatch('selectEmployee', {
                'id': employee.employee_id,
                'name': employee.employable.first_name + ' ' + employee.employable.last_name,
                'type': employee.employable_type
            });
            this.$router.push({
                path: '/employeeDetails/' + btoa(employee.employee_id)
            });
        },

        getEmpDetails() {
            this.$Progress.start();
            service.get('employee/' + this.employeeId, {
                'Authorization': this.userToken,
                'cs3-context-role': this.userRole,
                'cs3-context-clientId': this.userClientID
            })
            .then((res) => {
                this.$Progress.finish();
                this.userDateFormat = res.data.result.date_format;
                this.userTimeFormat = res.data.result.time_format;
            }).catch((err) => {
                console.log(err);
            });
        },

        navigateToEditEmployee(employee){
            let employeeId=btoa(employee.employee_id);
            this.$store.dispatch('setEditUserTab', 'admin');
            this.$router.push({
                'path': '/editEmployee/' + employeeId,
            });
        },

        getCustomField1(data) {
            if(data != '') {
                var customFld = "";
                try {
                    customFld = JSON.parse(data);
                    let re = -1;
                    let re2 = -1;
                    if(customFld != '' && customFld.value&&(typeof customFld.value == 'string'))
                    {
                        re = customFld.value.search('{\"name\":');
                        let inner = "";
                        if(re>=0) {
                            inner = JSON.parse(customFld.value);
                            if(inner&&inner != ''&&inner.value&&(typeof inner.value == 'string'))
                                re2 = inner.value.search('{\"name\":')
                            if(inner.value == "{}" || inner.value == "NULL" || inner.value == "null" || inner.value == "Null" || re2>=0)
                                return '';
                            return inner.value;
                        }else
                        return customFld&&customFld.value&& customFld.value !='{}' && customFld.value !='NULL' && customFld.value!='Null' && customFld.value != 'null' ? customFld.value : '';  
                    }
                    return "";
                } catch (ex) {
                    console.warn("Not a Valid JSON");
                    return "";
                }                    
            }
            return ""; 
        },

        getCustomField2(data) {
            if(data != '') {
                var customFld = "";
                try {
                    customFld = JSON.parse(data);
                    let re = -1;
                    let re2 = -1;
                    if(customFld != '' && customFld.value&&(typeof customFld.value == 'string'))
                    {
                        re = customFld.value.search('{\"name\":');
                        let inner = "";
                        if(re>=0) {
                            inner = JSON.parse(customFld.value);
                            if(inner&&inner != ''&&inner.value&&(typeof inner.value == 'string'))
                                re2 = customFld.value.search('{\"name\":')
                            if(inner.value == "{}" || inner.value == "NULL" || inner.value == "null" || inner.value == "Null" || re2>=0)
                                return '';
                            return inner.value;
                        }else
                        return customFld&&customFld.value&& customFld.value !='{}' && customFld.value !='NULL' && customFld.value!='Null' && customFld.value != 'null' ? customFld.value : '';  
                    }
                    return "";
                } catch (ex) {
                    console.warn("Not a Valid JSON");
                    return "";
                }                    
            }
            return "";
        },

        getRoundOffSkillSeniority(seniorityVal) {     
            if(seniorityVal && seniorityVal != '') {          
                if(seniorityVal.valueOf() == parseInt(seniorityVal)){
                    let x = parseInt(seniorityVal);
                    return x;
                }
            }
            return seniorityVal;
        },

        getUserDateFormat(dateTime) {
            return dateTimeConvert.localDate(dateTime);
        },

        async getAvailableEmployeesByTimeSlot() {
            if(this.end_time_slot == '') {
                this.$notify.error({
                    message: "Please select end time slot.",
                    title: 'End Time is Empty!'
                })
                return;
            }
            this.availableEmployees=[];
            this.notBookedEmployees=[];
            this.storeMore=[];
            this.loading=true;
            this.apiData=false;
            this.$Progress.start();
            let params = {
                'end': this.end_time_slot
            }
            await service.post('employee/assignPageEmployeeAvailibility', params, {
                'Authorization': this.userToken,
                'client-id': this.userClientID,
                'search': this.search_query,
                'employee-status-id': this.selectedStatusId,
                'sort-type': this.selectedSortType
            })
            .then((res) => {
                if(res.data&&res.data.result) {
                    this.loading=false;
                    this.apiData=true;
                    this.nextPageUrl = null;
                    this.notBookedStoreMore = res.data.result;
                    this.totalLimit = res.data.result.length?res.data.result.length:0;
                    this.currentPage = 1;
                    if(this.totalLimit <= this.pageSize){
                        this.notBookedEmployees = this.notBookedStoreMore;
                    }else{
                        this.onPageChange(1);
                    }
                    setTimeout(()=>{
                        this.isFirstPageLoad = true;
                    }, 5000);
                    this.$Progress.finish();
                }else {
                    this.loading=false;
                    this.$notify.error({
                        message: 'Please try again later.',
                        title: 'Something went wrong!'
                    })
                }
            }).catch((err) => {
                console.log(err);
                this.$Progress.finish();
                this.loading=false;
                this.apiData=true;
            });
        },

        getStatusName(name){
            let temp = name.substring(0, 3);
            return temp.toUpperCase();
        },

        checkElement(fieldName){
            for (var key in this.callAssignmentSettings) {
                if(this.callAssignmentSettings[key]==fieldName){
                    return true;
                }
            }
            return false;
        },

        // onPageChangeScrollUp(){
        //     if(this.isFirstPageLoad && this.notBookedEmployees.length && this.currentPage>1){
        //         this.lastLoadedPage = this.currentPage;
        //         this.currentPage = this.currentPage-1;
        //         this.isFirstPageLoad = false;
        //         setTimeout(()=>{
        //             this.isFirstPageLoad = true;
        //         }, 100);
        //         this.scrollType = "up";
        //     }
        // },

        // onPageChangeScrollDown(){
        //     let total = this.totalLimit/this.pageSize;
        //     if(this.isFirstPageLoad && this.notBookedEmployees.length && this.currentPage<=total){
        //         this.lastLoadedPage = this.currentPage;
        //         this.currentPage = this.currentPage+1;
        //         this.isFirstPageLoad = false;
        //         setTimeout(()=>{
        //             this.isFirstPageLoad = true;
        //         }, 100);
        //     }
        // },

        // onPageChange(val){
        //     let tempEmpList = this.storeMore;
        //     let buffer = 4;
        //     let end = (this.pageSize * this.currentPage);
        //     let start = end - this.pageSize;

        //     start = start - buffer;
        //     if(start < 0){
        //         start = 0
        //     }
        //     end = end + buffer;

        //     if(end > this.totalLimit){
        //         end =  this.totalLimit;
        //     }

        //     this.notBookedEmployees = this.notBookedStoreMore.slice(start, end-1);       
                                
        //     if(this.currentPage >= this.lastLoadedPage){
        //         $('#page-data-focus').scrollTop($('#scrollTop2').scrollTop());
        //         this.lastLoadedPage = this.currentPage;
        //         if(this.currentPage == this.lastLoadedPage){                  
        //             this.notBookedEmployees = this.notBookedStoreMore.slice(start, end+1);
        //         }
        //     }else{
        //         let last_position = this.totalLimit % this.pageSize;                    
        //         let position = "";
                
        //         if(this.scrollType == 'up' && this.lastLoadedPage == Math.ceil(this.totalLimit/this.pageSize)) {
        //             position = $('#scrollTop'+last_position).offset();
        //             $('#page-data-focus').scrollTop(position.top - $('#scrollTop'+last_position).scrollTop());
        //         } else {
        //             position = $('#scrollTop98').offset();
        //             $('#page-data-focus').scrollTop(position.top - $('#scrollTop98').scrollTop());
        //         }

        //         this.lastLoadedPage = this.currentPage;
        //     }
        //     this.scrollType = null;                
        // },

        onPageChangeScrollUp(){
            if (this.loading || this.ignoreScrollEvents) return;
            if (this.currentPage <= 1) return; // first page
            this.loading = true;
            this.isPaginationChange = true;
            this.scrollDirection = 'up';
            this.currentPage--;
            this.updatePagedData();
            this.loading = false;
        },

        updatePagedData() {
            const start = (this.currentPage - 1) * this.pageSize;
            const end = start + this.pageSize;

            if (this.isPaginationChange) {
                // On pagination click, replace with new slice
                this.notBookedEmployees = this.notBookedStoreMore.slice(start, end);
            } else if (this.scrollDirection === 'down') {
                const newItems = this.notBookedStoreMore.slice(start, end);

                // Filter to only add items not already present
                const existingIds = new Set(this.notBookedEmployees.map(e => e.id));
                const filteredNewItems = newItems.filter(item => !existingIds.has(item.id));

                // Only concat if there are new items (protects against double fire at last page)
                if (filteredNewItems.length > 0) {
                    this.notBookedEmployees = this.notBookedEmployees.concat(filteredNewItems);
                }
                // Else: do NOT modify employees, prevents duplicates
            } else if (this.scrollDirection === 'up') {
                // Only implement if you use upward infinite scroll
                // ...similar logic as above, with prepending
            }

            this.isPaginationChange = false;
            this.scrollDirection = null;
        },
        
        onPageChangeScrollDown(){
            if (this.loading) return;

            // Compute total number of pages:
            const totalPages = Math.ceil(this.totalLimit / this.pageSize);
            if (this.currentPage >= totalPages) return; // do NOT increment past last page

            this.loading = true;
            this.scrollDirection = 'down';
            this.isPaginationChange = false;
            this.currentPage++;
            this.updatePagedData();
            this.loading = false;
        },

        onPageChange(page){
            if (this.loading) return;

            this.loading = true;
            this.isPaginationChange = true;
            this.scrollDirection = null;
            this.currentPage = page;
            // Ignore scroll events during programmatic scrollTop setting
            this.ignoreScrollEvents = true;

            this.updatePagedData();

            this.$nextTick(() => {
                if (this.$refs.scrollContainer) {
                    this.$refs.scrollContainer.$refs.container.scrollTop = 0;
                }
                setTimeout(() => {
                    this.ignoreScrollEvents = false; // re-enable scroll handling after short delay
                }, 100);
                
                this.loading = false;
            });
        },

        getPower(data) {
            return dateTimeConvert.checkAccess(data);
        },

        recurringUnavailability(unavailability_list) {
            var flag=false;               
            let weekDaysNumbers = ["1","2","3","4","5","6","7"];
            let weekDaysNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
            if(unavailability_list && Object.keys(unavailability_list).length){
                let unavailabilityList = JSON.parse(unavailability_list);
                for(let i=0; i<weekDaysNumbers.length; i++) {
                    let unavailabilityList1=unavailabilityList[weekDaysNumbers[i]];  
                    for(var j=1; j<=Object.keys(unavailabilityList1).length; j++){
                        var temp = unavailabilityList1[j];
                        var start = this.callStartTime.split(' ')[0]+' '+temp[0]+':00';
                        var end = this.callStartTime.split(' ')[0]+' '+temp[1]+':00';
                        let overnightUnavailability = moment(start,'YYYY-MM-DD HH:mm:ss').isAfter(moment(end,'YYYY-MM-DD HH:mm:ss'));

                        if(overnightUnavailability) {  
                            if(start.split(' ')[0] == end.split(' ')[0]) {  
                                end = moment(end, 'YYYY-MM-DD HH:mm:ss').add(1, "d").format("YYYY-MM-DD HH:mm:ss"); 
                            }                                    
                            if(this.callStartTime.split(' ')[0] == this.callEndTime.split(' ')[0]) {
                                if(moment(this.callStartTime,'YYYY-MM-DD HH:mm:ss').format('dddd') == weekDaysNames[i+1]) {
                                    let flag1 = dateTimeConvert.dateCheck(start,end, this.callStartTime, this.callEndTime);
                                    return flag1;
                                }
                            } else {
                                end = this.callStartTime.split(' ')[0]+' '+temp[1]+':00';
                                if(moment(this.callStartTime,'YYYY-MM-DD HH:mm:ss').format('dddd') == weekDaysNames[i]) {
                                    let flag1 = dateTimeConvert.dateCheck(start,end, this.callStartTime, this.callEndTime);
                                    return flag1;
                                }else if(moment(this.callEndTime,'YYYY-MM-DD HH:mm:ss').format('dddd') == weekDaysNames[i+1]){
                                    let flag1 = dateTimeConvert.dateCheck(start,end, this.callStartTime, this.callEndTime);
                                    return flag1;
                                }
                            }

                            let overNightUnavailabilityEnd = moment(end, 'YYYY-MM-DD HH:mm:ss').add(1, "d").format("DD-MM-YYYY");

                            overNightUnavailabilityEnd = overNightUnavailabilityEnd + ' '+temp[1]+':00';

                            if(weekDaysNames[i] == (moment(overNightUnavailabilityEnd,'YYYY-MM-DD HH:mm:ss').format('dddd'))) {
                                let flag1 = dateTimeConvert.dateCheck(start,overNightUnavailabilityEnd, this.callStartTime, this.callEndTime);
                                return flag1;
                            }
                        }

                    }
                }
                return this.recurringUnavailability1(unavailability_list);
            }
            return flag;
        },

        recurringUnavailability1(unavailability_list){        
            let flag=false;
            if(unavailability_list && Object.keys(unavailability_list).length){
                let unavailabilityList = JSON.parse(unavailability_list);
                let dayNum1=moment(this.callStartTime).format('d');                                
                dayNum1=Number(dayNum1)+1;
                let unavailabilityList1=unavailabilityList[dayNum1];  
                for(var i=1; i<=Object.keys(unavailabilityList1).length; i++){
                    var temp = unavailabilityList1[i];
                    var start = this.callStartTime.split(' ')[0]+' '+temp[0]+':00';
                    var end = this.callStartTime.split(' ')[0]+' '+temp[1]+':00';                                               
                    if(dateTimeConvert.dateCheck(start, end, this.callStartTime, this.callEndTime)){
                        flag=true;
                        return flag;
                    }
                }
                let dayNum2=moment(this.callEndTime).format('d');
                dayNum2=Number(dayNum2)+1;
                if(this.callStartTime.split(' ')[0] != this.callEndTime.split(' ')[0]) {
                    let unavailabilityList2=unavailabilityList[dayNum2];
                    for(var i=1; i<=Object.keys(unavailabilityList2).length; i++){
                        var temp = unavailabilityList2[i];
                        var start = this.callEndTime.split(' ')[0]+' '+temp[0]+':00';
                        var end = this.callEndTime.split(' ')[0]+' '+temp[1]+':00';                                                  
                        if(dateTimeConvert.dateCheck(start, end, this.callStartTime, this.callEndTime)){
                            flag=true;
                            return flag;
                        }
                    }
                }
            }
            return flag;
        },

        checkVacationWithinCall(vacations) {
            if(vacations.length>0){
                return true;
            }
            return false;
        },

        getDeclineStatus(call_actions){
            let data = this.getCallActionByType(call_actions, "Declined");
            if((data.length>0 || Object.keys(data).length>0)){
                return true;
            }
            return false;                
        },

        getCallOutStatus(call_actions){
            let data = this.getCallActionByType(call_actions, "Call Out");
            if ((data.length > 0 || Object.keys(data).length>0)) {
                return true;
            } 
            return false;
        },

        getCallActionByType(call_action, type){
            let declines = [], passes = [], timeouts = [], callouts = [];
            if(call_action && call_action.length){
                call_action.forEach(call => {
                    switch(call.action_name){
                        case 'Declined':
                            declines.push(call);
                            break;
                        case 'Passed':
                            passes.push(call);
                            break;
                        case 'Call Out':
                            callouts.push(call);
                            break;
                        case 'Timed Out':
                            timeouts.push(call);
                            break;
                        default:
                            // console.log('call Action not found switch 1')
                    }
                });
            }
            switch(type){
                case 'Declined':
                    return declines;
                    break;
                case 'Passed':
                    return passes;
                    break;
                case 'Call Out':
                    return callouts;
                    break;
                case 'Timed Out':
                    return timeouts;
                    break;
                default:
                    // console.log('call Action not found switch 2')
            }
            return [];
        },

        sortDynamic(type){

            switch(type){
                case "employee_name":
                    if(this.selectedSortType=='fname_asc'){
                        this.selectedSortType='fname_desc';
                    }else{
                        this.selectedSortType='fname_asc';
                    }
                    break;

                case "skill_seniority":
                    if(this.selectedSortType=='skill_seniority'){
                        this.selectedSortType='skill_seniority_desc';
                    }else{
                        this.selectedSortType='skill_seniority';
                    }
                    break;

                case "employee_seniority":
                    if(this.selectedSortType=='emp_seniority'){
                        this.selectedSortType='emp_seniority_desc';
                    }else{
                        this.selectedSortType='emp_seniority';
                    }
                    break;

                case "shift_count_total":
                    if(this.selectedSortType=='shift_total_asc'){
                        this.selectedSortType='shift_total_desc';
                    }else{
                        this.selectedSortType='shift_total_asc';
                    }
                    break;

                case "shift_count_ytd":
                    if(this.selectedSortType=='shift_YTD_asc'){
                        this.selectedSortType='shift_YTD_desc';
                    }else{
                        this.selectedSortType='shift_YTD_asc';
                    }
                    break;

                case "shifts_this_week":
                    if(this.selectedSortType=='shift_weekly_asc'){
                        this.selectedSortType='shift_weekly_desc';
                    }else{
                        this.selectedSortType='shift_weekly_asc';
                    }
                    break;

                case "shifts_ytd_july_june":
                    if(this.selectedSortType=='shift_july_june_asc'){
                        this.selectedSortType='shift_july_june_desc';
                    }else{
                        this.selectedSortType='shift_july_june_asc';
                    }
                    break;

                case "declines_total":
                    if(this.selectedSortType=='decline_total__asc'){
                        this.selectedSortType='decline_total__desc';
                    }else{
                        this.selectedSortType='decline_total__asc';
                    }
                    break;

                case "declines_ytd":
                    if(this.selectedSortType=='decline_YTD_asc'){
                        this.selectedSortType='decline_YTD_desc';
                    }else{
                        this.selectedSortType='decline_YTD_asc';
                    }
                    break;

                case "declines_ytd_july_june":
                    if(this.selectedSortType=='decline_july_june_asc'){
                        this.selectedSortType='decline_july_june_desc';
                    }else{
                        this.selectedSortType='decline_july_june_asc';
                    }
                    break;

                case "decline_this_week":
                    if(this.selectedSortType=='decline_weekly_asc'){
                        this.selectedSortType='decline_weekly_desc';
                    }else{
                        this.selectedSortType='decline_weekly_asc';
                    }
                    break;
                
                case "employee_cell_phone":
                    if(this.selectedSortType=='phone_asc'){
                        this.selectedSortType='phone_desc';
                    }else{
                        this.selectedSortType='phone_asc';
                    }
                    break;

                case "conflicts":
                    if(this.selectedSortType=='conflicts_asc'){
                        this.selectedSortType='conflicts_desc';
                    }else{
                        this.selectedSortType='conflicts_asc';
                    }
                    break;

                case "location":
                    if(this.selectedSortType=='location_asc'){
                        this.selectedSortType='location_desc';
                    }else{
                        this.selectedSortType='location_asc';
                    }
                    break;

                case "participation":
                    if(this.selectedSortType=='participation_asc'){
                        this.selectedSortType='participation_desc';
                    }else{
                        this.selectedSortType='participation_asc';
                    }
                    break;

                case "participation_july_june_desc":
                    if(this.selectedSortType=='participation_july_june_desc'){
                        this.selectedSortType='participation_july_june_asc';
                    }else{
                        this.selectedSortType='participation_july_june_desc';
                    }
                    break;

                case "wishlist":
                    if(this.selectedSortType=='wishlist_asc'){
                        this.selectedSortType='wishlist_desc';
                    }else{
                        this.selectedSortType='wishlist_asc';
                    }
                    break;

                case "custom_field1":
                    if(this.selectedSortType=='custom_field1_asc'){
                        this.selectedSortType='custom_field1_desc';
                    }else{
                        this.selectedSortType='custom_field1_asc';
                    }
                    break;

                case "custom_field2":
                    if(this.selectedSortType=='custom_field2_asc'){
                        this.selectedSortType='custom_field2_desc';
                    }else{
                        this.selectedSortType='custom_field2_asc';
                    }
                    break;
            } 
            this.getAvailableEmployeesByTimeSlot();
        },
    },

    async beforeMount() {
        this.getBaseURL = global[0].IMAGE_URL;
        this.$Progress.start();
        this.loading=true;
        await service.get('employee/employee_status_lite', {
            'Authorization': this.userToken,
            'cs3-context-role': this.userRole,
            'cs3-context-clientId': this.userClientID
        }).
        then(async(res) => {
            this.statusList = res.data.result;
            this.$Progress.finish();
            let sortedStatusList = this.statusList.sort(function(a, b) {
                if (Number(a.priority) < Number(b.priority)) return -1;
                if (Number(a.priority) > Number(b.priority)) return 1;
                return 0;
            });
            this.selectedStatusId = sortedStatusList[0].id;
            this.tempStatus = this.selectedStatusId;
            await this.getClient();
            this.loading = false;
        }).catch((err) => {
            console.log(err);
            this.$Progress.finish();
        });
    },

    async created() {
        this.getEmpDetails();
        await this.resetEmployeeAvailabilityList();
        bus.$on('changeSort', (data) => {
            this.sortDynamic(data);
        });

        bus.$on('callUnDecline', (decline) => {
            this.getAvailableEmployeesByTimeSlot();
        });

        await this.getTodayJobList();
        await this.getSkills();
    },

    beforeDestroy(){
        $("#fc_frame").css('display', 'block');
        $(window).off('keydown');
        $('.v--modal-overlay.scrollable').css('overflow-y','auto');
    },

    components: {
        dynamicColumns,
        dynamicHeader
    },

    mounted() {
        this.getAvailableEmployeesList();
        let self = this;
        $(window).on('keydown', function(e) {
            if(e.keyCode === 40){
                document.getElementById('page-data-focus').focus();
                e.preventDefault();
                self.onPageChangeScrollDown();
            }else if(e.keyCode === 38){
                document.getElementById('page-data-focus').focus();
                e.preventDefault();
                self.onPageChangeScrollUp();
            }
        });
        var totalHeight = $('.o-header').height() + $('.table_header_wrapper').height()+100;
        var windowHeight = $(window).height();
        var adjustedHeight = windowHeight - totalHeight;
        if(adjustedHeight<250){
            $('.tbl-content').css('height', 200);
        }else{
            $('.tbl-content').css('height', adjustedHeight);
        }
        $("#fc_frame").css('display', 'none');
        $(this.$el).find('input').datetimepicker(this.config)
            .on('dp.show', (e) => {
                const picker = e.target; 
                const currentTime = moment();
                if (!picker.value) {
                    $(picker).data('DateTimePicker').date(currentTime);
                }
            });
    }
}
</script>


<style scoped>
    .phone-number-display {
        padding: 5px;
        cursor: pointer;
        color: #222222;
        text-decoration: none !important;
    }

    .tbl-content {
        height: 100%;
        max-height: 550px;
    }
    .pb-45 {
        padding-bottom: 45px!important;
    }
    .o-ndividualTable {
        padding: 10px;
    }
    .o-ndividualTable.assigntab .el-pagination-assign {
        width: 4%;
        max-width: 4%;
    }
    .o-ndividualTable.assigntab .table_main_content{
        width: 96%;
        max-width: 96%;
    }
    .start-now {
        padding:5px 10px;
        border:1px solid #080808;
        border-radius: 5px;
    }
    .ml-20 {
        margin-left: 20px;
    }
    .mt-10{
        margin-top:10px;
    }
    .mt-30 {
        margin-top: 30px;
    }
    .label-middle {
        margin: 10px 5px 10px 8px;
        letter-spacing: 1px;;
    }
    .filter-options {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
    }
</style>
